import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems } from '../data/offer';
export function OfferSection() {
  return <section className="w-full bg-cream-200" aria-labelledby="oferta-titulo" data-id="element-75" data-mp="3lzdls1rg34j">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" data-id="element-76" data-mp="8m3ydu9pbk0k">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start" data-id="element-77" data-mp="df6tw7y1h3je">
          <div className="lg:sticky lg:top-24" data-id="element-78" data-mp="idritb7uc0sj">
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-clay-600" data-id="element-79" data-mp="icylf0urunn2">
              La oferta
            </p>
            <h2 id="oferta-titulo" className="font-display text-3xl font-bold leading-tight text-forest-900 sm:text-4xl" data-id="element-80" data-mp="re662g4d7pyo">
              MEGAPACK: Conociendo la Longevidad Canina
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-forest-800/80" data-id="element-81" data-mp="2t6b3g74mvfgs">
              El sistema digital definitivo para dueños que quieren ver a su perro correr como un
              cachorro a los 15 años.
            </p>
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/ee14397a-68eb-41d1-baf3-07e1756bfadb.jpg" alt="Mockup del Megapack digital: guía maestra y cinco bonos" className="mt-8 aspect-[4/3] w-full rounded-3xl bg-white object-cover shadow-lg" data-id="element-82" data-mp="12otg7ix4xfjj" />
          </div>

          <ul className="space-y-4" data-id="element-83" data-mp="1lm4ep1ay04xx">
            {packItems.map((item, index) => <motion.li key={item.title} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.35,
            delay: index * 0.05,
            ease: 'easeOut'
          }} className="flex gap-4 rounded-2xl border border-cream-300 bg-cream-50 p-5 shadow-sm" data-id="element-84" data-mp="1gn9x22opomfe" data-mpi={index}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-forest-800" data-id="element-85" data-mp="3scawbgkdhzt3">
                  <CheckIcon className="h-4 w-4 text-cream-100" aria-hidden="true" data-id="element-86" data-mp="3ttq24lczy7ii" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-87" data-mp="2mn8ln9orp54">
                  <p className="text-xs font-bold uppercase tracking-wide text-clay-600" data-id="element-88" data-mp="2lc4tng8qhe0">
                    {item.tag}
                  </p>
                  <h3 className="mt-0.5 font-display text-xl font-bold text-forest-900" data-id="element-89" data-mp="3ou4yhxmvtazg">
                    {item.title}
                  </h3>
                  <p className="mt-1 leading-relaxed text-forest-800/75" data-id="element-90" data-mp="3b1f3x4taexqq">{item.description}</p>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}